<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-select v-if="type>1" v-model="query['owner.id']" :options="owners" clearable placeholder="placeholder.owner" @change="refresh"/>
        <vxe-input v-model="query.no" clearable placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" clearable placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="list" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.no" width="100"/>
        <vxe-column field="name" title="business.label.name" width="200"/>
        <vxe-column field="shortName" title="business.label.shortName" width="150"/>
        <vxe-column v-if="type>1" :formatter="({row})=>getStrings(row.owners,'name')" field="owners" title="business.label.owner" width="150"/>
        <vxe-column field="mnemonicCode" title="business.label.mnemonicCode" width="100"/>
        <vxe-column v-if="type>1" field="classification.name" title="business.label.classification" width="70"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:dataSources}" field="dataSource" title="business.label.dataSource" width="70"/>
        <vxe-column v-if="type>1" field="pickupMode.name" title="business.label.pickupMode" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column v-if="type===2" :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoAccepting" title="business.label.autoAccepting" width="70"/>
        <vxe-column v-if="type===2" :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoPutaway" title="business.label.autoPutaway" width="70"/>
        <vxe-column v-if="type===3" :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="autoPrint" title="business.label.autoPrint" width="70"/>
        <vxe-column v-if="type===3" :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="mergeOrder" title="business.label.mergeOrder" width="70"/>
        <vxe-column field="address.addressInfo.detailAddress" title="business.label.detailAddress"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { getStrings } from '@/utils/util'
import { Party } from '@/api/dto/common/Party'

export default {
  name: 'PartyList',
  props: {
    type: { type: Number, default: null },
    owners: { type: Array, default: [] },
    dataSources: { type: Array, default: [] }
  },
  data() {
    return {
      loading: false,
      query: { no: '', name: '', 'owner.id': undefined },
      list: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    getStrings,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      const args = {
        ...this.query,
        'type.ordinal': this.type
      }
      this.loading = true
      findAll('partyFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.list = res.result.map(item => {
            return new Party(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { no: '', name: '', 'owner.id': undefined }
      this.refresh()
    },
    add() {
      this.$emit('add')
    },
    edit(row, copy) {
      this.$emit('edit', row.id, copy)
    }
  }
}
</script>